import React from "react";
import { connect } from "react-redux";
import classNames from 'classnames';
// import buttons from "ui-components/src/button/button.module.scss";
import { ReactComponent as VIdle } from "ui-components/src/images/monochrome-icons/ic-v-idle.svg";
import { ReactComponent as VSelected } from "ui-components/src/images/monochrome-icons/ic-v-selected.svg";
import CloudCentralSecondaryHeader from "../headers/CloudCentralSecondaryHeader";
import styles from "./PartnerCenter.module.scss";
import partners from "./partners";
import { registerFeature } from "../../middlewares/apiMiddleware";
import partnerMiddleware from "../../middlewares/featureApis/partnersMiddleware";
import _ from "lodash";

registerFeature("PARTNERS", partnerMiddleware);

const PartnerCard = ({ name, image, imageDimensions, redirectUrl, chosen, handleCheckClick, handleUncheckClick }) => (
    <div className={chosen ? classNames(styles["partner-container"], styles.chosen) : styles["partner-container"]}>
        {chosen ? <VSelected className={styles.select} onClick={() => handleUncheckClick()}/> : <VIdle className={styles.select} onClick={() => handleCheckClick(name)}/>}
        <img className={styles.icon} style={imageDimensions} src={require(`./images/${image}`)} alt={name}/>
        {redirectUrl && <a href={redirectUrl} className={styles["learn-more"]}>Learn more</a>}
    </div>
);


class PartnerDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chosen: this.props.associatedPartner,
            partners: partners.map(partner => {
                partner.chosen = partner.name === this.props.associatedPartner;
                return partner;
            })
        };
        this.handleCheckClick = this.handleCheckClick.bind(this);
        this.handleUncheckClick = this.handleUncheckClick.bind(this);
        // this.handleAssociation = this.handleAssociation.bind(this);
        this.backToGallery = this.backToGallery.bind(this);
    }

    componentDidUpdate(prevProps){
        if(prevProps.associatedPartner !== this.props.associatedPartner){
            this.setState({
                partners: partners.map(p => {
                    p.chosen = p.name === this.props.associatedPartner;
                    return p;
                })
            });
        }
    }

    handleCheckClick(partenr) {
        this.setState({
            chosen: partenr,
            partners: partners.map(p => {
                p.chosen = p.name === partenr;
                return p;
            })
        });
        this.props.associate(partenr);
    }

    handleUncheckClick() {
        this.setState({
            chosen: null,
            partners: partners.map(p => {
                p.chosen = false;
                return p;
            })
        });
        this.props.associate(null);
    }

    // handleAssociation() {
    //     if (this.props.associatedPartner === this.state.chosen) {
    //         return;
    //     }
    //     this.props.associate(this.state.chosen);
    // }

    backToGallery() {
        this.props.backToGalley();
    }

    render() {
        const partnerDetails = _.find(partners, ['name', this.props.associatedPartner]);
        const restOfPartners = _.reject(this.state.partners, ['name', this.props.associatedPartner]);
        return (
            <div>
                <React.Fragment>
                    <CloudCentralSecondaryHeader title="Partner Center">
                    </CloudCentralSecondaryHeader>
                    <div className={styles.gallery}>
                        <React.Fragment>
                            {partnerDetails && <PartnerCard key={partnerDetails.name + 1000} handleCheckClick={this.handleCheckClick} handleUncheckClick={this.handleUncheckClick} {...partnerDetails}/>}
                            {restOfPartners.map((partner, i) => <PartnerCard key={partner.name + i} handleCheckClick={this.handleCheckClick} handleUncheckClick={this.handleUncheckClick} {...partner}/>)}
                        </React.Fragment>
                    </div>
                    <footer className={classNames(styles["main-footer"], "nav-adjusted-fixed-pane")}>
                        {/*<button className={buttons.primary} onClick={this.handleAssociation}>Associate My Account</button>*/}
                        {this.props.error && <span>{this.props.error}</span>}
                    </footer>
                </React.Fragment>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    associatedPartner: state.partners.userPartner,
    error: state.partners.error,
    associatedSuccessfully: state.partners.associatedSuccessfully
});

const mapDispatchToProps = dispatch => ({
    associate: partner => {
        dispatch({
            type: "PARTNERS:ASSOCIATE-PARTNER",
            payload: {
                partner
            }
        });
    },
    backToGalley: () => dispatch({ type: "PARTNERS:SHOW-GALLERY" })
});

export default connect(mapStateToProps, mapDispatchToProps)(PartnerDisplay);
